import type { ReactNode } from "react";
import styles from "./SelectionToolbar.module.css";

/** Barra de la tabla (SelectionToolbar.razor): con selección, la barra de acciones (toolbar); sin ella, el contenido. */
export function SelectionToolbar({
  count,
  label,
  selected,
  children,
}: {
  count: number;
  label: string;
  selected: ReactNode;
  children: ReactNode;
}) {
  return (
    <div
      className={`bh-table-toolbar ${count > 0 ? "bh-selection-toolbar" : ""} ${styles.scope}`}
      role={count > 0 ? "toolbar" : undefined}
      aria-label={label}
    >
      {count > 0 ? selected : children}
    </div>
  );
}
